// Node Modules
import * as React from "react";
import {
  HashRouter,
  Switch,
  Route,
} from "react-router-dom";
import ReactDOM from 'react-dom';

import registerServiceWorker from './pwa/registerServiceWorker';

// JSX Containers
import { App } from './components/App';
import BlogLeetcodeValidParentheses from './components/blog/BlogLeetcodeValidParentheses';
import TetrisPage from './components/TetrisPage';

// CSS
import './components/css/index.css';

const app = (
  <HashRouter>
    <Switch>
      <Route path = "/blog/leetcode-valid-parentheses">
        <BlogLeetcodeValidParentheses />
      </Route>
      <Route path = "/tetris">
        <TetrisPage />
      </Route>
      <Route path = "/">
        <App />
      </Route>
    </Switch>
  </HashRouter>
);

ReactDOM.render(
  app,
  document.getElementById('root')
);

// PWA
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js